import React, { Children, cloneElement } from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// STYLES
import styles from './pageButtons.module.scss';
          
// MAIN COMPONENT
const PageButtons = ({
  className,
  children
}) => {

  // RENDER
  return (
    <div className={clsx(styles.buttons, className)}>
      {Children.map(children, (child, i) => !child ? null : cloneElement(child, {
        key: i,
        size: 'sm'
      }))}
    </div>
  );
};

// EXPORT
export default PageButtons;
